<template>
  <div class="row justify-content-center">
    <div class="col-lg-9">
      <div class="card">
        <div class="card-header">
          Create New Monetization Criteria
        </div>
        <div class="card-body">
          <form action="" @submit.prevent="submit">
            <div v-for="(criteria,i) in criterias" class="row mt-3">
              <!--              <h3>Criteria 1</h3>-->
              <div class="form-group col-md-4">
                <label>Criteria title</label>
                <input type="text" class="form-control" v-model="criteria.name" placeholder="Name">
              </div>
              <div class="form-group col-md-4">
                <label>Criteria</label>
                <select name="type" id="type" class="form-control" v-model="criteria.type">
                  <option value="views">Views</option>
                  <option value="unique_views">Unique Views</option>
                  <option value="subscriptions">Subscriptions</option>
                  <option value="likes">Likes</option>
                  <option value="comments">Comments</option>
                </select>
              </div>
              <div class="form-group col-md-4">

                <label for="">Calculate by</label>
                <select name="type" id="type" class="form-control" v-model="criteria.calculation_type">
                  <option value="range">Range</option>
                  <option value="multiplication">Multiplication</option>
                </select>
              </div>
              <div class="form-group col-md-3" v-if="criteria.calculation_type==='range'">
                <label>From {{ criteria.type }} number</label>
                <input type="text" class="form-control" :placeholder="`${criteria.type} number`" v-model="criteria.min">
              </div>
              <div class="form-group col-md-3" v-if="criteria.calculation_type==='range'">
                <label>To {{ criteria.type }} number(0 infinite)</label>
                <input type="text" class="form-control" :placeholder="`${criteria.type} number`" v-model="criteria.max">
              </div>
              <div class="form-group "
                   :class="{'col-md-4':criteria.calculation_type==='range','col-md-10':criteria.calculation_type==='multiplication'}">
                <label v-if="criteria.calculation_type==='range'">Amount</label>
                <label v-else>How much for 1 {{ criteria.type }}?</label>
                <input type="text" class="form-control" placeholder="Amount" v-model="criteria.amount">
              </div>
              <div class="form-group col-md-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <button class="btn btn-outline--danger btn-block w-100" :disabled="criterias.length===1"
                        style="padding: 11px 0px"
                        @click.prevent="()=>remove(i)">Remove
                </button>
              </div>
              <div class="col-md-12" v-if="i!==criterias.length-1">
                <hr>
              </div>
            </div>
            <button class="btn btn--info px-6 float-right mt-2" type="button" style="padding: 10px;float: right"
                    @click.prevent="addRow">
              ADD A ROW
            </button>
            <button type="submit" class="btn btn--primary" style="padding: 10px;">SUBMIT CRITERIA</button>
          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "create-criteria",
  props: ["monetization"],
  data() {
    return {
      criterias: []
    }
  },
  methods: {
    remove(index) {
      this.criterias.splice(index, 1)
    },
    addRow() {
      this.criterias.push({
        id: null,
        max: 0,
        min: 0,
        name: "",
        type: "views",
        amount: 0,
        calculation_type: "range"
      })
    },
    async submit() {
      console.log(this.criterias)
      const reqObject = this.criterias.map(criteria => {
        return {
          ...criteria,
          name: criteria.name,
          type: criteria.type,
          calculation_type: criteria.calculation_type,
          amount: criteria.amount,
          min: criteria.calculation_type === 'range' ? criteria.min : null,
          max: criteria.calculation_type === 'range' ? criteria.max : null,
        }
      })
      try{
        const res = await axios.post('/admin/monetization-criteria', reqObject)
        console.log(res);
        notify('success', 'Criteria created successfully')
      }catch (e) {
        this.criterias= this.monetization;
        console.log("Something went wrong")
      }

    }
  },
  mounted() {
    console.log(this.monetization)
    this.criterias = this.monetization;
  }
}
</script>

<style scoped>

</style>